export default __webpack_public_path__ + "static/media/Danske_Bank.8bded5f1.svg";